import { App } from './core/App.js';
import { LoadingScreen } from './ui/HUD.js';

/**
 * Entry point.
 *
 * Everything interesting lives in `core/App.js`; this file only wires the app
 * to the page and reports fatal boot errors somewhere the user can see them.
 */
const canvas = document.getElementById('viewport');

async function boot() {
  try {
    const app = new App(canvas);
    await app.load();

    // Handy for poking at the scene from the console.
    window.app = app;

    // Development-only smoke harness. It is gated behind an explicit query
    // string and removed after automated visual verification.
    if (new URLSearchParams(location.search).has('constructSmoke')) {
      const ids = ['prism', 'horizon', 'razor', 'tide', 'sunwheel'];
      ids.forEach((id, index) => setTimeout(() => {
        const origin = app.character.position.clone();
        const direction = app.aim.direction.clone().normalize();
        app.abilities.cast(origin, direction, 12 + index * 0.5, id);
      }, 700 + index * 1400));
    }
  } catch (error) {
    console.error('[boot] failed to start', error);
    new LoadingScreen().fail(
      error?.message ? `Failed to start: ${error.message}` : 'Failed to start — see the console.'
    );
  }
}

boot();
